import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import * as actions from "../../../actions/actions";
import classNames from "classnames";

import ProcessButton from "../../../legacy/components/processbutton";
import { Captcha } from "../../captcha";

class SignupForm extends React.Component {
    state = {
        success: false,
    };

    UNSAFE_componentWillMount() {
        this.props.authFormClearErrors();
        this.props.authFormClearData();
    }

    onSuccess = res => {
        this.setState({ success: true });

        if (this.props.onSuccess) {
            this.props.onSuccess();
            return;
        }

        let redirectHref = this.props.next ? this.props.next : res.location;
        return this.props.redirect(redirectHref);
    };

    signUp = e => {
        e.preventDefault();
        if (this.props.accountSignupRequireCaptcha && !this.props.captchaToken) {
            this.props.authFormError(
                "captcha_token",
                "Complete captcha to create an account",
            );
            return;
        }

        this.props
            .signUp(this.props.signupType)
            .then(res => {
                this.onSuccess(res);
            })
            .catch(() => null);
    };

    formHasErrors = () => {
        return this.props.error || Object.keys(this.props.fieldErrors).length > 0;
    };

    handleFocus = () => {
        if (this.formHasErrors()) {
            this.props.authFormClearErrors();
        }
    };

    handleTeamNameInputChange = e =>
        this.props.authFormInputChange({ teamName: e.target.value });

    handleLoginInputChange = e =>
        this.props.authFormInputChange({ login: e.target.value });

    handlePasswordInputChange = e =>
        this.props.authFormInputChange({ password: e.target.value });

    handleReceiveUpdatesInputChange = e =>
        this.props.authFormInputChange({ receiveUpdates: e.target.checked });

    handleAcceptTermsInputChange = e => {
        this.handleFocus();
        this.props.authFormInputChange({ acceptTerms: e.target.checked });
    };

    handleCaptchaInputChange = token => {
        this.handleFocus();
        this.props.authFormInputChange({ captchaToken: token });
    };

    handleLoginLinkClick = e => {
        if (this.props.showLogin) {
            e.preventDefault();
            this.props.showLogin();
        }
    };

    render() {
        const {
            team_name: teamNameFieldError,
            email: emailFieldError,
            password1: passwordFieldError,
            accept_terms: acceptTermsFieldError,
            captcha_token: captchaError,
        } = this.props.fieldErrors;

        let status;

        if (this.state.success) status = "success";
        if (this.formHasErrors()) status = "failure";
        if (this.props.processing) status = "processing";

        let authPath = this.props.authPathOverride || "/accounts/login/";

        const teamNameInput = (
            <li>
                <input
                    tabIndex="1"
                    id="id_team_name"
                    className={classNames({
                        "error on": teamNameFieldError,
                    })}
                    name="team_name"
                    placeholder="Team Name"
                    value={this.props.teamName}
                    onChange={this.handleTeamNameInputChange}
                    type="text"
                    maxLength="50"
                    required
                    autoFocus
                />
                <label
                    htmlFor="id_team_name"
                    className={classNames("show", {
                        "error on": teamNameFieldError,
                    })}
                >
                    {teamNameFieldError ? teamNameFieldError : "Team Name"}
                </label>
                <label htmlFor="id_team_name" className="ui_icon ui_team-accounts" />
            </li>
        );

        let captcha;
        if (this.props.accountSignupRequireCaptcha) {
            let captchaClasses = classNames("captcha-container", {
                "with-error": !!captchaError,
            });
            captcha = (
                <li className={captchaClasses}>
                    <Captcha handleToken={this.handleCaptchaInputChange} />
                    <div className="signup-errors">{captchaError}</div>
                </li>
            );
        }

        return (
            <React.Fragment>
                <div id="form-container" className="auth-form-container">
                    <form
                        id="create-account"
                        data-test="signup-form"
                        className={`new-form dark-form form-${this.props.accentColor}`}
                        onSubmit={this.signUp}
                    >
                        <div className="signup-errors general-error">
                            {this.props.error}
                        </div>
                        <ol className="sign-up-fields">
                            {this.props.signupType === "team" ? teamNameInput : null}
                            <li className="text-input-container">
                                <input
                                    tabIndex="3"
                                    id="id_email"
                                    className={classNames({
                                        "error on": emailFieldError,
                                    })}
                                    maxLength="254"
                                    name="email"
                                    type="email"
                                    placeholder="Email Address"
                                    value={this.props.login}
                                    onChange={this.handleLoginInputChange}
                                    onFocus={this.handleFocus}
                                    data-test="signup-form-email-input"
                                    autoComplete="off"
                                    required
                                />

                                <label
                                    htmlFor="user_id"
                                    className={classNames("show", {
                                        "error on": emailFieldError,
                                    })}
                                >
                                    {emailFieldError ? emailFieldError : "Email"}
                                </label>
                                <label htmlFor="user_id" className="ui_icon ui_user" />
                            </li>

                            <li className="text-input-container">
                                <input
                                    tabIndex="4"
                                    id="id_password"
                                    maxLength="4096"
                                    name="password"
                                    type="password"
                                    placeholder="Password"
                                    className={classNames({
                                        "error on": passwordFieldError,
                                    })}
                                    required
                                    value={this.props.password}
                                    onChange={this.handlePasswordInputChange}
                                    onFocus={this.handleFocus}
                                    data-test="signup-form-password-input"
                                />

                                <label
                                    htmlFor="id_password"
                                    className={classNames("show", {
                                        "error on": passwordFieldError,
                                    })}
                                >
                                    {passwordFieldError ? passwordFieldError : "Password"}
                                </label>
                                <label
                                    htmlFor="id_password"
                                    className="ui_icon ui_lock"
                                />
                            </li>
                            <li className="margin-t-xl margin-l-m receive-updates-container">
                                <label
                                    htmlFor="receive_updates"
                                    className="display-flex flex-align-center flex-justify-start check-box-label-container"
                                >
                                    <input
                                        id="receive_updates"
                                        name="receive_updates"
                                        className="checkbox-input"
                                        type="checkbox"
                                        checked={this.props.receiveUpdates}
                                        onChange={this.handleReceiveUpdatesInputChange}
                                        data-test="signup-form-receive-updates-input"
                                    />
                                    <label
                                        htmlFor="receive_updates"
                                        className="checkbox-fillin"
                                    >
                                        <i className="ui_check-mark" />
                                    </label>
                                    <span>
                                        Send me occasional emails about the
                                        Noun&nbsp;Project community.
                                    </span>
                                </label>
                            </li>

                            <li className="margin-l-m accept-terms-container">
                                <label
                                    htmlFor="accept_terms"
                                    className="display-flex flex-align-center flex-justify-start check-box-label-container"
                                >
                                    <input
                                        id="accept_terms"
                                        className="checkbox-input"
                                        name="accept_terms"
                                        type="checkbox"
                                        checked={this.props.acceptTerms}
                                        onChange={this.handleAcceptTermsInputChange}
                                        data-test="signup-form-accept-terms-input"
                                    />
                                    <label
                                        htmlFor="accept_terms"
                                        className={classNames("checkbox-fillin", {
                                            "error on": acceptTermsFieldError,
                                        })}
                                    >
                                        <i className="ui_check-mark" />
                                    </label>
                                    <span>
                                        I agree to the{" "}
                                        <a
                                            href="/legal/terms-of-use/"
                                            className="text-link color-white"
                                            target="_blank"
                                        >
                                            Terms of Use
                                        </a>
                                        .
                                    </span>
                                </label>
                                <label htmlFor="accept_terms" className="signup-errors">
                                    {acceptTermsFieldError}
                                </label>
                            </li>
                            {captcha}
                        </ol>
                        <ol className="sign-up-buttons margin-t-m">
                            <li className="process-button-wrapper">
                                <ProcessButton
                                    buttonState={status}
                                    buttonText="Create my account"
                                    color={this.props.accentColor}
                                    iconClass="ui_key"
                                    extraClass="full-width"
                                />
                            </li>
                        </ol>
                    </form>
                </div>
                <div className="login-link align-center">
                    {this.props.loginLink || (
                        <a
                            data-test="login-page-link"
                            className="already-have-an-account text-link"
                            href={`${authPath}${
                                this.props.next ? `?next=${this.props.next}` : ``
                            }`}
                            onClick={this.handleLoginLinkClick}
                        >
                            Already have an account? Log in.
                        </a>
                    )}
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    const { auth } = state;
    let { accountSignupRequireCaptcha } = auth;
    let { fieldErrors } = auth;

    // If the server sent back a captcha error, force
    // showing the captcha
    if (fieldErrors && fieldErrors.captcha_token) {
        accountSignupRequireCaptcha = true;
    }

    return {
        error: auth.error,
        fieldErrors,
        login: auth.login,
        password: auth.password,
        processing: auth.processing,
        receiveUpdates: auth.receiveUpdates,
        acceptTerms: auth.acceptTerms,
        teamName: auth.teamName,
        captchaToken: auth.captchaToken,
        accountSignupRequireCaptcha,
    };
};

SignupForm.defaultProps = {
    signupType: "basic",
    accentColor: "green",
};

SignupForm.propTypes = {
    accentColor: PropTypes.oneOf(["blue", "green"]),
};

SignupForm = connect(mapStateToProps, {
    signUp: actions.signUp,
    authFormInputChange: actions.authFormInputChange,
    authFormClearErrors: actions.authFormClearErrors,
    redirect: actions.redirect,
    authFormClearData: actions.authFormClearData,
    authFormError: actions.authFormError,
})(SignupForm);

export default SignupForm;
